import React, { useState, useEffect } from "react";
import Header from "../components/utils/Header";
import SectionProductBacklog from "../components/productBacklog/Section";
import List from "../components/productBacklog/List";
import Footer from "../components/utils/Footer";
import { useFirebase } from "../database/FirebaseContext";
import { collection, onSnapshot } from "firebase/firestore";
import { getLocalUser } from "../database/localStorage";
import { database } from "../database/firebase-config";
import ResetPasswordForm from "../components/teamManagement/ResetPasswordForm"


function ProductBacklog({colourBlindMode, onColourBlindMode, offColourBlindMode}) {
    document.title = "Product Backlog";
    
    const { getUser, getAllUsersData } = useFirebase();
    const [tasks, setTasks] = useState([]);
    const { getAllPBTasks, sortPBTasks, filterByTaskTag } = useFirebase();
    const [userRoles, setUserRoles] = useState("");
	const [currentUser, setCurrentUser] = useState({});
    const [modalChangePassword, setModalChangePassword] = useState("false")

    const openModalChangePassword = () => {
        setModalChangePassword(true);
    };

    // make the task detail hidden
    const closeModalChangePassword = () => {
        setModalChangePassword(false);
    };


    const getSortedTasks = async (priority) => {
        const sortedTasks = await sortPBTasks(priority);
        const sortedData = sortedTasks.map((task) => ({
            ...task,
        }));
        setTasks(sortedData);
    };

    const getFilteredTasks = async (categoryTag) => {
        const filteredTasks =
            categoryTag !== "None"
                ? await filterByTaskTag(categoryTag)
                : await getAllPBTasks();
        const filteredData = filteredTasks.map((task) => ({
            ...task,
        }));
        setTasks(filteredData);
    };

    useEffect(() => {
        const collectionRef = collection(database, "product-backlog");
        const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            data.sort(
                (a, b) =>
                    (a.createdAt?.toMillis() || 0) -
                    (b.createdAt?.toMillis() || 0)
            );
            setTasks(data);
        });

        const updateCurrentUser = async () => {
            const user = await getUser(
                getLocalUser().userName,
                getLocalUser().userPassword
            );
            setCurrentUser(user);
            setUserRoles(user.userRole);
        };

        updateCurrentUser();
        return () => unsubscribe();
    }, []);

    

    

    return (
        <div>
            <Header
                roles={currentUser.userRole}
                openModal={openModalChangePassword}
                colourBlindMode={colourBlindMode}
                onColourBlindMode={onColourBlindMode}
                offColourBlindMode={offColourBlindMode}
            />
            <SectionProductBacklog
                title={"Product Backlog"}
                onSort={getSortedTasks}
                onFilter={getFilteredTasks}
                colourBlindMode={colourBlindMode}
            />
            {modalChangePassword === true && (
                <ResetPasswordForm
                    onClose={closeModalChangePassword}
                />
            )}
            <div class=" flex relative">
                <div class="overflow-y-scroll w-full h-[80vh]">
                    <List colourBlindMode={colourBlindMode} tasks={tasks} />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ProductBacklog;
